import { render, staticRenderFns } from "./AppRegister.vue?vue&type=template&id=7bbec2c2&scoped=true"
import script from "./AppRegister.vue?vue&type=script&lang=js"
export * from "./AppRegister.vue?vue&type=script&lang=js"
import style0 from "./AppRegister.vue?vue&type=style&index=0&id=7bbec2c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbec2c2",
  null
  
)

export default component.exports